import * as React from 'react';
import { cityIn } from 'lvovich';
import { SegmentStopFragment } from '@websky/graphql';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import { getDurationString } from '../../../../Results/utils';
import { getTransferLabel } from '../../../utils';
import cn from 'classnames';

interface Props {
	stops?: SegmentStopFragment[];
	stopCityName?: string;
	transferDuration?: Duration;
	className?: string;
	separator?: string;
}

const StopsInfo: React.FC<Props> = ({ stops, stopCityName, transferDuration, className, separator = '-' }) => {
	const { t } = useTranslation('DesktopFlightInfo');

	const theme = useTheme('DesktopFlightRoute').StopsInfoStyles;

	return (
		<div className={cn(theme.stop, className)}>
			<span className={theme.stop__label}>
				{stops.length > 0 &&
					`${t('DesktopFlightInfo:TechnicalLandingIn', {
						count: stops.length
					})} ${stops
						.map(
							stop =>
								`${cityIn(stop.airport?.city?.name)}${
									stop?.duration ? ` ${separator} ${getDurationString(stop.duration)}` : ''
								}`
						)
						.join(', ')}. `}

				<span>{transferDuration && getTransferLabel(t, stopCityName, transferDuration, separator)}</span>
			</span>
		</div>
	);
};

export default StopsInfo;
